import PageContentWrapper from './PageContentWrapper';

export default PageContentWrapper;



// WEBPACK FOOTER //
// ./src/components/Page/PageContentWrapper/index.tsx